export default "__VITE_ASSET__DKjtZFxr__"